import script from "./ScoreEchart.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreEchart.vue?vue&type=script&setup=true&lang=js"

import "./ScoreEchart.vue?vue&type=style&index=0&id=69ec5137&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69ec5137"]])

export default __exports__